/**
 * Content Processor Utility
 * Processes blog post HTML content to fix media URLs
 */

export const processContentUrls = (htmlContent) => {
  if (!htmlContent) return '';
  
  const API_BASE = process.env.REACT_APP_API_URL || 'https://supernovalab.ai/api';
  const baseUrl = API_BASE.replace('/api', '');
  
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlContent;
  
  // Fix image URLs
  const images = tempDiv.querySelectorAll('img');
  images.forEach(img => {
    const src = img.getAttribute('src');
    if (src && src.startsWith('/uploads/')) {
      img.setAttribute('src', `${baseUrl}${src}`);
    }
  });
  
  // Fix video URLs
  const videos = tempDiv.querySelectorAll('video source');
  videos.forEach(source => {
    const src = source.getAttribute('src');
    if (src && src.startsWith('/uploads/')) {
      source.setAttribute('src', `${baseUrl}${src}`);
    }
  });
  
  // Fix link URLs
  const links = tempDiv.querySelectorAll('a');
  links.forEach(link => {
    const href = link.getAttribute('href');
    if (href && href.startsWith('/uploads/')) {
      link.setAttribute('href', `${baseUrl}${href}`);
    }
  });
  
  // ✅ Wrap tables in responsive container
  const tables = tempDiv.querySelectorAll('table');
  tables.forEach(table => {
    if (!table.parentElement.classList.contains('table-wrapper')) {
      const wrapper = document.createElement('div');
      wrapper.className = 'table-wrapper';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  });
  
  // ✅ Wrap iframes (videos) in responsive container
  const iframes = tempDiv.querySelectorAll('iframe');
  iframes.forEach(iframe => {
    if (!iframe.parentElement.classList.contains('video-wrapper')) {
      const wrapper = document.createElement('div');
      wrapper.className = 'video-wrapper';
      iframe.parentNode.insertBefore(wrapper, iframe);
      wrapper.appendChild(iframe);
    }
  });
  
  return tempDiv.innerHTML;
};

export const sanitizeContent = (htmlContent) => {
  if (!htmlContent) return '';
  
  let sanitized = htmlContent.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
  sanitized = sanitized.replace(/on\w+\s*=\s*["'][^"']*["']/gi, '');
  
  return sanitized;
};